import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '../user-service/userservice';

/** Prevents direct navigation around Construct-X's organisation-administration UI. */
@Injectable({ providedIn: 'root' })
export class OrganisationAdminGuard implements CanActivate {
  constructor(private readonly users: UserService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const organisationId = [...route.pathFromRoot].reverse()
      .map(snapshot => Number(snapshot.paramMap.get('organisationId')))
      .find(id => Number.isInteger(id) && id > 0);
    if (organisationId && this.users.isUserAdminOfOrganisationOrPlattformAdmin(organisationId)) return true;
    return this.router.createUrlTree(organisationId ? ['/organisations', organisationId, 'information'] : ['/marktplatz']);
  }
}
